import { Box, CircularProgress } from "@mui/material";

function CircularProgressCentered(): React.JSX.Element {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <CircularProgress />
    </Box>
  );
}

export { CircularProgressCentered };
